/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable indent */
import React, { Component } from 'react';
import SignUpForm from './Form';
import OtpScreen from '../Otp';
import UserService from '../../../Service/UserService';
import { Auth } from 'aws-amplify';
import { whenUserLoggedIn } from '../../../AppUtil/AppUtil';
import Session from '../../../Service/Session';
import axios from 'axios';
import AccountService from '../../../Service/AccountService';

const APP_STRING = window.AppStrings;

class SignUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_signUser: null,
			_authUser: {},
			_isOtpScreenOpen: false,
			_isSignUpFormLoaderOn: false,
			_signUpError: '',
			_otpScreenMode: 'mobile',
			_isEmailDuplicate: false,
			_isError: false,
			_errorMessage: '',
			_isMobileDuplicate: false,
			_isNewPasswordChallengedCompleted: false
		};
	}

	signUp = async (user, fileDetailsArr) => {
		this.setState({
			_isSignUpFormLoaderOn: true,
			_signUser: user
		});

		try {
			const userObj = {
				first_name: user.first_name,
				last_name: user.last_name,
				email: user.email,
				phone: user.phone,
				birth_date: user.birth_date,
				region: user.region
			};

			const subscribe = await AccountService.createContact(userObj);

			if (subscribe.data.status_code !== 201) {
				console.log(subscribe.data.message);
				return this.setState({
					_isError: true,
					_errorMessage: subscribe.data.message,
					_isSignUpFormLoaderOn: false
				});
			}

			if (subscribe.data.status_code === 201) {
				const createdUser = await UserService.create(user);

				if (createdUser.status) {
					const next = await this.sendLoginRequest();
					if (next) {
						this.redirectToOtpScreen(APP_STRING.MOBILE);
					} else {
						await this.logedUserIn();
					}
				} else {
					if (createdUser.data.indexOf(APP_STRING.EMAIL) > -1) {
						this.setState({
							_isEmailDuplicate: true
						});
					}
					if (createdUser.data.indexOf('phone') > -1) {
						this.setState({
							_isMobileDuplicate: true
						});
					}
				}

				if (createdUser.data.user.id) {
					for (let fileDetails of fileDetailsArr) {
						const value = fileDetails.file.value;

						const typeObj = {
							type: 'putObject',
							fileName: value.name,
							folder: fileDetails.id
						};

						const resp = await UserService.signedUrlUploadId(createdUser.data.user.id, typeObj);
						await axios.put(resp.data.signedUrl, value, {
							headers: {
								'Content-Type': ''
							}
						});
					}
					const idData = await UserService.signedUrlUploadId(createdUser.data.user.id, { type: 'getObject' });
					Session.store(APP_STRING.UPLOAD_ID, idData);
				}
			}

			this.setState({
				_isSignUpFormLoaderOn: false
			});
		} catch (err) {
			this.setState({
				_isSignUpFormLoaderOn: false
			});
		}
	};

	redirectToOtpScreen = mode => {
		this.setState({
			_isOtpScreenOpen: true,
			_otpScreenMode: mode
		});
	};

	verifyLogin = async otp => {
		await Auth.confirmSignIn(this.state._authUser, otp, 'SMS_MFA');
		await this.sendEmailVerificationRequest();
		this.redirectToOtpScreen(APP_STRING.EMAIL);
	};

	sendLoginRequest = async () => {
		let result = true;
		const authUser = await Auth.signIn(this.state._signUser.phone, this.state._signUser.password);
		if (!this.state._isNewPasswordChallengedCompleted) {
			await Auth.completeNewPassword(authUser, this.state._signUser.password);
			this.setState({
				_isNewPasswordChallengedCompleted: true
			});
		}
		this.setState({
			_authUser: authUser
		});
		if (!authUser.challengeName) {
			result = false;
		}
		return result;
	};

	verifyEmail = async otp => {
		await Auth.verifyCurrentUserAttributeSubmit(APP_STRING.EMAIL, otp);
		await this.logedUserIn();
	};

	logedUserIn = async () => {
		await whenUserLoggedIn(this.props, '/app/account-created', 'PROFILE');
	};

	sendEmailVerificationRequest = async () => {
		await Auth.verifyCurrentUserAttribute(APP_STRING.EMAIL);
	};

	resetFormError = () => {
		this.setState({
			_isEmailDuplicate: false,
			_isMobileDuplicate: false
		});
	};

	render() {
		if (!this.state._isOtpScreenOpen) {
			return (
				<SignUpForm
					isEmailDuplicate={this.state._isEmailDuplicate}
					isMobileDuplicate={this.state._isMobileDuplicate}
					isSignUpFormLoaderOn={this.state._isSignUpFormLoaderOn}
					onSubmit={this.signUp}
					openSignInForm={this.props.openSignInForm}
					resetFormError={this.resetFormError}
					signUpError={this.state._signUpError}
					supportedStates={this.props.supportedStates}
					user={this.props.user}
					footer={this.props.footer}
					isError={this.state._isError}
					errorMessage={this.state._errorMessage}
				/>
			);
		} else {
			return (
				<OtpScreen
					mode={this.state._otpScreenMode}
					resendOtp={
						this.state._otpScreenMode === APP_STRING.EMAIL
							? this.sendEmailVerificationRequest
							: this.sendLoginRequest
					}
					verifyOtp={this.state._otpScreenMode === APP_STRING.EMAIL ? this.verifyEmail : this.verifyLogin}
				/>
			);
		}
	}
}

export default SignUp;
